import { render, staticRenderFns } from "./TransferOrChangeClueForm.vue?vue&type=template&id=f3eacf36"
import script from "./TransferOrChangeClueForm.vue?vue&type=script&lang=js"
export * from "./TransferOrChangeClueForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports